<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <base-notice-item
    button-text="Enter insurance information"
    :button-url="buttonUrl"
    status="Information missing"
    data-test="ir35-insurance-alert"
  >
    <template #head>
      <strong>{{ $t('Insurance information') }}</strong>
    </template>
    <template #icon>
      <img
        src="/gfx/ir35-logo-indigo.svg"
        class="pull-right m-l-10"
        style="max-width: 40px; height: auto"
      />
    </template>
    <template #body>
      Your insurance information related to IR35 will be applied to Status Determination Statements
      (SDS) on new contracts in Worksome when applicable.

      <p v-if="yjob !== null && hasAnsweredAllQuestions">
        This job may fall within the off-payroll working rules known as ‘IR35’.
        <br />
        If the hire is determined to be inside IR35, tax and national insurance will need to be paid
        prior to final payouts from bills.
        <br />
        <a
          href="https://help.worksome.dk/en/articles/3669299-worksome-s-ir35-guide-for-freelancers"
          target="_blank"
          class="f-500"
        >
          Get more help in our IR35 Guide
          <i class="zmdi zmdi-open-in-new"></i>
        </a>
      </p>
    </template>
  </base-notice-item>
</template>

<script>
/* eslint-disable import/extensions */
import RedirectUriMixin from '@/mixins/RedirectUriMixin'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export default {
  name: 'Ir35InsuranceFreelancerAlert',
  mixins: [RedirectUriMixin],
  props: {
    hasAnsweredAllQuestions: {
      type: Boolean,
      required: true,
    },
    yjob: {
      type: Object,
      default() {
        return null
      },
    },
  },
  computed: {
    buttonUrl() {
      const baseUrl = laravelNamedRoute(
        namedRoutes.frontend.user.profile.edit,
        {
          redirect_uri: this.redirectUri,
        },
        false,
      )
      return `${baseUrl}#insurance-information`
    },
  },
}
</script>
